import { render, staticRenderFns } from "./ProjectHeaderResources.vue?vue&type=template&id=b2165198&scoped=true"
import script from "./ProjectHeaderResources.vue?vue&type=script&lang=ts"
export * from "./ProjectHeaderResources.vue?vue&type=script&lang=ts"
import style0 from "./ProjectHeaderResources.vue?vue&type=style&index=0&id=b2165198&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2165198",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2165198')) {
      api.createRecord('b2165198', component.options)
    } else {
      api.reload('b2165198', component.options)
    }
    module.hot.accept("./ProjectHeaderResources.vue?vue&type=template&id=b2165198&scoped=true", function () {
      api.rerender('b2165198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/ProjectHeaderResources.vue"
export default component.exports